// extracted by mini-css-extract-plugin
export var connectionButton = "_b5-1";
export var rightPanel = "_b5-3";
export var stepDescription = "_b5-2";
export var stepIcon = "_b5-0";